import React, {useState, useCallback, Fragment} from 'react';
import classNames from 'classnames';
import BackButton from './BackButton';
import Icon from './Icon';
import NavLink from './NavLink';
import ActiveFlag from './ActiveFlag';
import isLinkActive from './isLinkActive';

function Tertiary({headLink, links}) {
    return (
        <div className="p-5">
            <div className="row">
                {!headLink ? null : (
                    <div className="col-12">
                        <NavLink {...headLink}/>
                        {!headLink.description ? null :
                            <p className={`mx-5`}>{headLink.description}</p>
                        }
                    </div>
                )}
                {!links ? null : links.map((link, i) => (
                    <div key={i} className="col-12 col-lg-6 position-relative">
                        {link.active ? <ActiveFlag className="pl-2 pt-2 pt-lg-3"/> : null}
                        <a className="btn btn-link"
                            data-category={link.dataCategory}
                            data-action={link.dataAction}
                            data-label={link.dataLabel}
                           href={link.url}>
                            <span className="lead">{link.title}</span>
                            {!link.description ? null : (
                                <span className="d-block pt-2 pl-3 pr-5">{link.description}</span>
                            )}
                        </a>
                    </div>
                ))}
            </div>
        </div>
    );
}

export default function NavMenuMega(props) {
    const [selectedPrimaryIndex, setSelectedPrimaryIndex] = useState(-1);
    const [selectedSecondaryIndex, setSelectedSecondaryIndex] = useState(-1);
    const [open, setOpen] = useState(false);
    const ref = useCallback(node => {
        const groups = node.querySelectorAll('.mega-secondary');
        Array.from(groups).forEach(group => {
            const backButton = group.querySelector('.back-btn');
            const subgroup = group.nextElementSibling;
            subgroup.addEventListener('focusout', event => {
                if (!subgroup.contains(event.relatedTarget) && !group.contains(event.relatedTarget)) {
                    backButton.focus();
                }
            });
        });

    }, []);
    return (
        <section ref={ref} className={classNames({
            mega: true,
            active: open,
        })}>

            {props.navMenu.links.map((primaryLink, primaryIndex) => (
                <Fragment key={primaryIndex}>
                    <div
                        className={classNames({
                            'mega-secondary': true,
                            'active': (primaryIndex === selectedPrimaryIndex),
                        })}
                    >

                        <div className={classNames({
                            'invisible': !open || primaryIndex !== selectedPrimaryIndex,
                        })}>
                            <BackButton onClick={() => setOpen(false)}/>
                        </div>

                        <NavLink className="level-1" {...primaryLink}/>
                        <div className="mega-rule text-secondary">
                            <Icon.Ring/>
                        </div>

                        {primaryLink.links.map((secondaryLink, secondaryIndex) => (
                            <div key={secondaryIndex}
                                 className={classNames({
                                     'position-relative': true,
                                     'mega-secondary-option': true,
                                     'mega-secondary-option-selected': open && selectedSecondaryIndex === secondaryIndex,
                                 })}
                            >
                                {isLinkActive(secondaryLink) ? <ActiveFlag className="pl-2 pt-2 pt-lg-3"/> : null}
                                {secondaryLink.links && secondaryLink.links.length > 0 ? (
                                    <button className="btn btn-link btn-block font-weight-bold"
                                            onClick={() => {
                                                setSelectedPrimaryIndex(primaryIndex);
                                                setSelectedSecondaryIndex(secondaryIndex);
                                                setOpen(true);
                                            }}
                                            aria-controls={`tertiary-link-group-${primaryIndex}`}
                                            aria-expanded={open && selectedPrimaryIndex === primaryIndex && selectedSecondaryIndex === secondaryIndex ? 'true' : 'false'}
                                    >
                                        <span>{secondaryLink.title}</span>
                                        <Icon.ChevronRight/>
                                    </button>
                                ) : (
                                    <a className="btn btn-link btn-block font-weight-bold"
                                        data-category={secondaryLink.dataCategory}
                                        data-action={secondaryLink.dataAction}
                                        data-label={secondaryLink.dataLabel}
                                       href={secondaryLink.url}
                                    >
                                        <span>{secondaryLink.title}</span>
                                    </a>
                                )}
                            </div>
                        ))}

                    </div>
                    <div className="mega-tertiary" id={`tertiary-link-group-${primaryIndex}`}>
                        {selectedPrimaryIndex >= 0 && selectedSecondaryIndex >= 0 ?

                            <Tertiary
                                headLink={props.navMenu.links[selectedPrimaryIndex].links[selectedSecondaryIndex]}
                                links={props.navMenu.links[selectedPrimaryIndex].links[selectedSecondaryIndex].links}
                            />

                            : null}
                    </div>
                </Fragment>
            ))}

        </section>
    );
};
